export const Spacing = { 
  s01: "0.125rem", //2px
  s02: "0.25rem", //4px
  s03: "0.5rem", //8px
  s04: "0.75rem", //12px
  s05: "1rem",//16px
  s06: "1.25rem", //20px
  s07: "1.5rem",//24px
  s08: "2rem",//32px
  s09: "2.5rem", //40px
  s10: "3rem",//48px
  s11: "3.5rem", //56px
  s12: "4rem",//64px
  s13: "4.5rem",//72px
  s14: "5rem", //80px
  s15: "6rem", //96px
  s16: "7rem", //112px
  s17: "8rem", //128px
  s18: "10rem", //160px
  s19: "11rem", //176px
  s20: "12rem", //192px


  videowall: {
    xxxs: "0.105vw", //In Cascais (7680x2169) = 8.0px
    xxs: "0.209vw", //In Cascais (7680x2169) = 16.0px
    xs: "0.313vw",//In Cascais (7680x2169) = 24.0px
    sm: "0.417vw",//In Cascais (7680x2169) = 32.0px
    md: "0.547vw",//In Cascais (7680x2169) = 42.0px
    lg: "0.678vw",//In Cascais (7680x2169) = 52.0px
    xl: "0.756vw",//In Cascais (7680x2169) = 58.0px
    xxl: "0.834vw",//In Cascais (7680x2169) = 64.0px,
    xxxl: "0.939vw"//In Cascais (7680x2169) = 72.1px,
  }
};